'use client';

import Link from 'next/link';
import { ThemeAwareLogoWithText } from '../ui/ThemeAwareLogoWithText';

interface PoweredByFooterProps {
  className?: string;
}

export function PoweredByFooter({ className = '' }: PoweredByFooterProps) {
  return (
    <div className={`w-full py-1 border-t border-gray-100 flex justify-center items-center bg-background/60 backdrop-blur-sm ${className}`}>
      <div className="flex flex-row items-center gap-1.5 min-h-5">
        <span className="text-xs text-muted-foreground/70 leading-5 m-0">Powered by</span>
        <Link
          href="https://fomogo.in"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center shrink-0 h-5"
        >
          <ThemeAwareLogoWithText
            width={90}
            height={20}
            className="block opacity-80 hover:opacity-100 object-contain"
          />
        </Link>
      </div>
    </div>
  );
} 